/**
 * Admin API client — typed fetch wrapper per /api/v1/admin/*.
 *
 * Pattern identico ad `archivio-client.ts`:
 *  - `credentials: 'include'` per portare il cookie Better Auth.
 *  - Errori sollevati come `AdminApiError` con `status` + `code`.
 */
import type { ScadenzeResponse } from '@app/shared';

const API = '/api/v1/admin';

export class AdminApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'AdminApiError';
    this.status = status;
    this.code = code;
  }
}

async function parseError(res: Response): Promise<{ code: string; message: string }> {
  const body = await res.json().catch(() => ({})) as { code?: string; message?: string };
  return {
    code: body.code ?? 'UNKNOWN',
    message: body.message ?? 'Errore sconosciuto',
  };
}

export async function fetchScadenze(
  filter: 'upcoming' | 'past' | 'all' = 'all',
): Promise<ScadenzeResponse> {
  const params = new URLSearchParams({ filter });
  const res = await fetch(`${API}/scadenze?${params}`, { credentials: 'include' });
  if (!res.ok) {
    const { code, message } = await parseError(res);
    throw new AdminApiError(res.status, code, message);
  }
  return res.json() as Promise<ScadenzeResponse>;
}
